export const ADMIN_GROUP = 'ALPHA_ADMIN';
